import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncParishDetailsMobile({ ...rest }) {
  const AsyncLoad = loadable(() => import("../parishDetailsMobilePage"));
  console.log("Loading", AsyncParishDetailsMobile.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncParishDetailsMobile;
